import { useCallback } from 'react'

import { preview } from '@/components/form/preview'
import { useController } from '../../hooks/useController'

import type { TabValues } from '../../../../typings'
import { OrderAvatar } from '../../../OrderAvatar'
import { HeaderLoading } from '../HeaderLoading'
import { PreviewActions } from './components/PreviewActions'
import { PreviewTabs } from '../../../shared/PreviewTabs'

export function Header() {
  const {
    close,
    data: { tab, extOrderStep, loadingData },
    updateData,
  } = useController()

  const setTab = useCallback(
    (number: TabValues) => {
      updateData({ tab: number })
    },
    [updateData],
  )

  if (loadingData) return <HeaderLoading />

  if (!extOrderStep) {
    return null
  }

  const subtitle = extOrderStep.atDepot
    ? extOrderStep.depot.name
    : extOrderStep.location.address || extOrderStep.location.geoAddress || ''

  return (
    <div style={{ paddingLeft: 24, paddingTop: 24 }}>
      <preview.Header
        title={extOrderStep.order.name}
        subtitle={subtitle}
        testId="orderPreviewModal-header"
        avatar={
          <OrderAvatar extendedOrderStep={extOrderStep} style={{ marginRight: 16 }} size={42} />
        }
        onClose={close}
      >
        <PreviewActions tab={tab} order={extOrderStep} />

        <PreviewTabs tab={tab} setTab={setTab} testIdPrefix="orderPreviewModal__tab-" />
      </preview.Header>
    </div>
  )
}
